module.exports = __webpack_public_path__ + "assets/stand23.ff05c800cb08c4043f9878967e663864.png";


/*****************
 ** WEBPACK FOOTER
 ** ./img/stand23.png
 ** module id = 218
 ** module chunks = 0
 **/